// src/protocols/thorchain/index.ts
var THORCHAIN_HINTS = {
  valueHints: [],
  callHints: [
    { protocolId: "thorchain", call: "depositWithExpiry", component: "GenericCall", label: "THORChain deposit request", summaryFields: ["vault", "asset", "amount", "memo", "expiration"] },
    { protocolId: "thorchain", call: "transferOut", component: "GenericCall", label: "THORChain router transfer", summaryFields: ["to", "asset", "amount", "memo"] },
    { protocolId: "thorchain", call: "transferOutAndCall", component: "GenericCall", label: "THORChain router contract call", summaryFields: ["aggregator", "finalToken", "to", "amountOutMin", "memo"] }
  ],
  eventHints: [
    { protocolId: "thorchain", event: "Deposit", component: "GenericEvent", label: "THORChain deposit event", summaryFields: ["to", "asset", "amount", "memo"] },
    { protocolId: "thorchain", event: "TransferOut", component: "GenericEvent", label: "THORChain router transfer event", summaryFields: ["to", "asset", "amount", "memo"] },
    { protocolId: "thorchain", event: "TransferOutAndCall", component: "GenericEvent", label: "THORChain router contract-call event", summaryFields: ["target", "finalAsset", "to", "amount", "amountOutMin", "memo"] }
  ]
};
function registerThorchain(registry) {
  registry.registerHints(THORCHAIN_HINTS);
  return registry;
}

export { THORCHAIN_HINTS, registerThorchain };
//# sourceMappingURL=chunk-AO5WJ2LG.js.map
//# sourceMappingURL=chunk-AO5WJ2LG.js.map